import { createContext, useContext } from "react";

const FetcherCacheContext = createContext();

export function useFetcherCache() {
  return useContext(FetcherCacheContext);
}

export default FetcherCacheContext;
